import { ActionsProducer } from './Types';
import ServiceProducer from '../../Services/ServiceProducer';
import { Producer, IFaena } from '../../Models/Report';

const service = new ServiceProducer();

export const createActionRequestProducer = () => ({
	type: ActionsProducer.REQUEST_PRODUCER
})


export const createActionFetchProducer = () => {
	return (dispatch: any) => {
		dispatch(createActionRequestProducer())
		service.fetch()
		.then(async r  => {
			const res: IFaena[] = await r.json();
			const producers = Producer.transform(res, -1);
			dispatch({
				type: ActionsProducer.FETCH_PRODUCERS,
				payload: producers
			})
			dispatch(createActionRequestProducer())
		})
		.catch( e  => {

		})
	}
}
